export default __webpack_public_path__ + "static/jerzy-kalinowski-bc5203e8019456ab93ee19ed9facaf67.jpg";